const REFERENCE_ASSETS = require('../reference-assets.json');
const coins = require('../coins');

module.exports = [
  {
    dataIndex: 0,
    id: 'aave',
    name: 'aave',
    lpTokenInfo: {
        name: 'aaveCurve',
        symbol: 'a3Crv',
    },
    coingeckoInfo: {
        id: 'aave',
        symbol: 'AAVE',
    },
    assets: 'aDAI+aUSDC+aUSDT',
    coins: [
        coins.adai,
        coins.ausdc,
        coins.ausdt,
    ],
    underlyingCoins: [
        coins.dai,
        coins.usdc,
        coins.usdt,
    ],
    isLendingPool: true,
    isModernLendingPool: true,
    addresses: {
        swap: '0x445FE580eF8d70FF569aB36e80c647af338db351',
        lpToken: '0xE7a24EF0C5e95Ffb0f6684b813A78F2a3AD7D171',
        gauge: '0x19793B454D3AfC7b454F206Ffe95aDE26cA6912c',
        old_gauge: '0xe381C25de995d62b453aF8B931aAc84fcCaa7A62'
    },
    gaugeVersion: 3, // No CRV rewards
    additionalRewards: [{
        key: 'CRV3POOL',
        name: 'CRV',
        amountDataKey: 'crvRewards3Pool',
        rewardTokenAddress: '0x172370d5cd63279efa6d502dab29171933a610af',
        rewardTokenDecimals: 18,
        rewardTokenCoingeckoId: 'curve-dao-token',
        rewardContract: '0xC48f4653dd6a9509De44c92beb0604BEA3AEe714'
    },{
        key: 'WMATIC3POOL',
        name: 'WMATIC',
        rewardTokenCoingeckoId: 'matic-network',
        rewardTokenDecimals: 18,
        rewardTokenAddress: '0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270',
        rewardContract: '0xC48f4653dd6a9509De44c92beb0604BEA3AEe714'
    }],
    hasNoCRVRewards: true,
  },
  {
  dataIndex: 1,
  id: 'atricrypto',
  name: 'atricrypto',
  lpTokenInfo: {
      name: '3CrvCrypto',
      symbol: '3CrvCrypto',
  },
  assets: 'adai+ausdc+ausdt+aeth+abtc',
  coins: [
      coins.dai,
      coins.usdc,
      coins.usdt,
      coins.wbtc,
      coins.weth,
  ],
  addresses: {
      swap: '0x751B1e21756bDbc307CBcC5085c042a0e9AaEf36',
      lpToken: '0x8096ac61db23291252574D49f036f0f9ed8ab390',
      deposit: '0x3FCD5De6A9fC8A99995c406c77DDa3eD7E406f81',
      gauge: '0xb0a366b987d77b5eD5803cBd95C80bB6DEaB48C0',
  },
  cryptoPool: true,
  referenceAsset: REFERENCE_ASSETS.CRYPTO,
  isFakePlainPool: true,
  gaugeVersion: 3, // No CRV rewards
  additionalRewards: [{
      key: 'CRVATRICRYPTO',
      name: 'CRV',
      amountDataKey: 'crvRewardsaTriCrypto',
      rewardTokenAddress: '0x172370d5cd63279efa6d502dab29171933a610af',
      rewardTokenDecimals: 18,
      rewardTokenCoingeckoId: 'curve-dao-token',
      rewardContract: '0x060e386eCfBacf42Aa72171Af9EFe17b3993fC4F'
  },{
      key: 'WMATICATRICRYPTO',
      name: 'WMATIC',
      amountDataKey: 'maticRewards',
      rewardTokenCoingeckoId: 'matic-network',
      rewardTokenDecimals: 18,
      rewardTokenAddress: '0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270',
      rewardContract: '0x060e386eCfBacf42Aa72171Af9EFe17b3993fC4F'
  }],
  hasNoCRVRewards: true,

}, {
  dataIndex: 2,
  id: 'ren',
  name: 'ren',
  lpTokenInfo: {
      name: 'renCurve',
      symbol: 'renCrv',
  },
  coingeckoInfo: {
      id: 'renbtc',
      symbol: 'RENBTC',
      referenceAssetId: 'bitcoin',
  },
  assets: 'awBTC+renBTC',
  coins: [
      coins.amwbtc,
      coins.renbtc
  ],
  underlyingCoins: [
      coins.wbtc,
      coins.renbtc
  ],
  isLendingPool: true,
  referenceAsset: REFERENCE_ASSETS.BTC,
  isModernLendingPool: true,
  addresses: {
      swap: '0xC2d95EEF97Ec6C17551d45e77B590dc1F9117C67',
      lpToken: '0xf8a57c1d3b9629b77b6726a042ca48990A84Fb49',
      gauge: '0xffbACcE0CC7C19d46132f1258FC16CF6871D153c',
      old_gauge: '0x93b14f53528a59e655d8ce39bdba443dcddddc4c'
  },
  gaugeVersion: 3, // No CRV rewards
  additionalRewards: [{
      key: 'CRVREN',
      name: 'CRV',
      amountDataKey: 'crvRewardsRen',
      rewardTokenAddress: '0x172370d5cd63279efa6d502dab29171933a610af',
      rewardTokenDecimals: 18,
      rewardTokenCoingeckoId: 'curve-dao-token',
      rewardContract: '0x488E6ef919C2bB9de535C634a80afb0114DA8F62'
  },{
      key: 'WMATICREN',
      name: 'WMATIC',
      amountDataKey: 'maticRewards',
      rewardTokenCoingeckoId: 'matic-network',
      rewardTokenDecimals: 18,
      rewardTokenAddress: '0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270',
      rewardContract: '0x488E6ef919C2bB9de535C634a80afb0114DA8F62'
  }],
  hasNoCRVRewards: true,

}
];
